import { atom, useAtomValue, useSetAtom } from 'jotai';

const storeToken = atom();

export const useTokenStoreValue = () => useAtomValue(storeToken);
export const useTokenStoreSet = () => useSetAtom(storeToken);
